import app from '@/app';

/* @ngInject */
function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
	$localStorageProvider.setKeyPrefix('jhi-');
	$sessionStorageProvider.setKeyPrefix('jhi-');
}

app.config(localStorageConfig);
